import { render, staticRenderFns } from "./DashboardBarCard.vue?vue&type=template&id=9369000a&scoped=true&"
import script from "./DashboardBarCard.vue?vue&type=script&lang=js&"
export * from "./DashboardBarCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBarCard.vue?vue&type=style&index=0&id=9369000a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9369000a",
  null
  
)

export default component.exports